import cf from './cf';
import c51v from './c51v_20211024';

export default class c51v1a extends c51v {

  constructor(props) { // state の宣言だけでは駄目な模様
    super(props);
    this.d_viewDefs = {
      class: 'c51v1a',
      name: '設定'
    };
    this.state = cf.myRN_crt_stss(
      this.$cd_stss,
      this.$id_stss
    );
  }

}
